
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree2e0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree2e0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2idp8", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aPniE"),
    $parcel$import("gRrHH"),
    $parcel$import("6IEd9")
]).then(()=>parcelRequire('dJ5La'));

});

parcelRegister("79at7", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("aPniE"),
    $parcel$import("gRrHH"),
    $parcel$import("6N7ZJ")
]).then(()=>parcelRequire('lH6c8'));

});

var $219bcedbb4577909$exports = {};
$parcel$extendImportMap({
    "6IEd9": "phase2-mobile.42350ac8.js",
    "gRrHH": "entrance-mobile.cde4202b.js",
    "aPniE": "phase2-mobile.080700df.js",
    "6N7ZJ": "phase2.216de4dd.js"
});

/**
 * homepage-entrance-phase2.js — top-level entry attached via Drupal library.
 *
 * Does cheap eligibility checks synchronously, then lazy-loads the heavy
 * orchestrator (three.js + GSAP) in the next idle window. Keeps the LCP
 * budget clean.
 */ function $5a96c7592a5d65b0$var$ready() {
    return document.readyState === 'loading' ? new Promise((r)=>document.addEventListener('DOMContentLoaded', r, {
            once: true
        })) : Promise.resolve();
}
function $5a96c7592a5d65b0$var$prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $5a96c7592a5d65b0$var$hasWebGL() {
    try {
        const c = document.createElement('canvas');
        return !!(c.getContext('webgl2') || c.getContext('webgl'));
    } catch (e) {
        return false;
    }
}


async function $5a96c7592a5d65b0$var$boot() {
    await $5a96c7592a5d65b0$var$ready();
    const root = document.querySelector('[data-phase2-root]');
    if (!root) return;
    // Reduced-motion path boots so we catch bootstrap bugs early; CSS + `inert`
    // keep the animation invisible to the user and keyboard-inaccessible.
    // WebGL absence aborts hard — no point booting an orchestrator that can't render.
    if (!$5a96c7592a5d65b0$var$hasWebGL()) return;
    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    const runBoot = async ()=>{
        try {
            if (isMobile) {
                const mod = await (parcelRequire("2idp8"));
                await mod.initPhase2Mobile();
            } else {
                const mod = await (parcelRequire("79at7"));
                await mod.initPhase2();
            }
        } catch (err) {
            console.warn('[phase2] orchestrator load failed; fallback remains.', err);
        }
    };
    if ('requestIdleCallback' in window) requestIdleCallback(runBoot, {
        timeout: 2000
    });
    else setTimeout(runBoot, 0);
}
$5a96c7592a5d65b0$var$boot();


//# sourceMappingURL=homepage-entrance-phase2.js.map
